// @flow
import { handleResponseOld, makeGet } from './helpers';

type GetTopRatedHousesParams = {
    authToken: string,
    deployment: string,
};

export default {
    getTopRatedHouses: ({ authToken, deployment }: GetTopRatedHousesParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: 'gettopratedhouses',
                authToken,
                deployment,
                path: '<REVIEW-API>',
            });
            request.query({});
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
